import { ExtraOptions, provideRouter, Routes, withRouterConfig } from '@angular/router';
import { AuthCallbackComponent, cognitoAuthGuard } from './core/auth';

export const routes: Routes = [
    {
        path: 'auth/callback',
        component: AuthCallbackComponent
    },
    {
        path: '',
        canActivate: [cognitoAuthGuard],
        loadChildren: () => import('./pages/pages.routes').then((m) => m.PAGES_ROUTES)
    },
    { path: '', redirectTo: 'pages', pathMatch: 'full' },
    { path: '**', redirectTo: 'pages' }
];

const config: ExtraOptions = {
    useHash: false
};

export const appRoutingProviders = [provideRouter(routes, withRouterConfig(config))];
